"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelectScrollableStack = useSelectScrollableStack;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _SelectInline = require("@commerce-ui/core2/SelectInline");
var _useScrollableStack = _interopRequireWildcard(require("./useScrollableStack"));
var _excluded = ["scrollableStack"],
  _excluded2 = ["sx", "controller", "children"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useSelectScrollableStack() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$scrollableStac = props.scrollableStack,
    scrollableStack = _props$scrollableStac === void 0 ? {} : _props$scrollableStac,
    selectInlineProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var selectInlineController;
  var scrollableStackController;
  selectInlineController = (0, _SelectInline.useSelectInline)(selectInlineProps);
  (0, _react.useEffect)(function () {
    scrollableStackController.setFloatingElementIndex(selectInlineController.selectedIndex);
  }, [selectInlineController.selectedIndex]);
  scrollableStackController = (0, _useScrollableStack.useScrollableStack)(_objectSpread(_objectSpread({}, scrollableStack), {}, {
    length: props.options.length,
    initialFloatingElementIndex: selectInlineController.selectedIndex
  }));
  return _objectSpread(_objectSpread({}, selectInlineController), {}, {
    scrollableStack: scrollableStackController
  });
}
function SelectScrollableStack(props) {
  var sx = props.sx,
    controller = props.controller,
    children = props.children,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  if (!controller) {
    controller = useSelectScrollableStack(_objectSpread({}, props));
  }
  var selectInlineController = _objectSpread({}, controller);
  delete selectInlineController.scrollableStack;
  var scrollableStackController = controller.scrollableStack;
  var itemElement = _react["default"].Children.only(children);
  children = selectInlineController.selectableProps.map(function (props) {
    return /*#__PURE__*/_react["default"].cloneElement(itemElement, props);
  });
  return __jsx(_useScrollableStack["default"], {
    nextButton: props.nextButton,
    previousButton: props.previousButton,
    controller: scrollableStackController,
    sx: sx
  }, children);
}
var _default = SelectScrollableStack;
exports["default"] = _default;